const echartsOptionsKCFB = [{
	numCharts: 3,
	legend: {
		bottom: '5%',
	},
	tooltip: {
		confine: true,
		hideDelay: 3000,
		trigger: 'item',
		formatter: '{b}: {c} ({d}%)'
	},
	series: [{
		type: 'pie',
		radius: "55%",
		center: ["50%", "27%"],
		label: {
			show: true,
			position: 'inner',
			color: '#ffffff',
			width: 50,
			overflow: 'breakAll',
		},
		emphasis: {
			label: {
				show: true
			}
		},
	}]
}];
export default echartsOptionsKCFB;
